import React, { useEffect, useState } from "react";
import styles from "./DiscountManagement.module.css";
import { InputField, SubmitButton } from "../../../components";
import HeadingComponent from "../../../components/HeadingComponent/HeadingComponent";
import { showAlert } from "../../../Store/Actions/GeneralActions";
import { useDispatch, useSelector } from "react-redux";
import { DatePicker, Popconfirm } from "antd";
import { PagesMiddleware } from "../../../Store/Middlewares/PagesMiddleware";
import moment from "moment/moment";
import { DeleteOutlined } from "@ant-design/icons";
import Pagination from "../../../components/Pagination/Pagination";

const DiscountManagement = () => {

  const dispatch = useDispatch()
  const [discountVal, setdiscountVal] = useState("");
  const [expiryDate, setExpiryDate] = useState("");
  const [discountPercentage, setDiscountPercentage] = useState("");

  const DATA = useSelector(state => state.PagesReducer?.discountCodes);
  const DATA_PAGINATION = useSelector(state => state.PagesReducer?.discountCodesPagination);

  const [currentPage, setCurrentPage] = useState(1)
  const [pageLimit, setPageLimit] = useState(5);

  useEffect(() => {
    getData()
  }, []);

  const getData = (arg) => {
    const data = {
      limit: pageLimit,
      page: 1,
    }
    dispatch(PagesMiddleware.getDiscountCodes(arg || data))
      .then((res) => { })
      .catch((err) => { console.log("error", err) });
  }

  const onAddCode = () => {
    if (!discountVal) {
      dispatch(showAlert({ message: "Please enter a discount code", type: "warning" }))
    }
    else if (!discountPercentage) {
      dispatch(showAlert({ message: "Please enter discount percentage", type: "warning" }))
    }
    else if(discountPercentage > 100){
      dispatch(showAlert({ message: "Discount percentage cannot be greater than 100", type: "warning" }))
    }
    else if(discountPercentage == 0){
      dispatch(showAlert({ message: "Discount percentage cannot be 0", type: "warning" }))
    }
     else if(discountPercentage == 100){
      dispatch(showAlert({ message: "Discount percentage should be less than 100", type: "warning" }))
    }
    else if (!expiryDate) {
      dispatch(showAlert({ message: "Please select an expiry date", type: "warning" }))
    }

    else {
      const data = { code: discountVal, percentage: parseInt(discountPercentage), expiryDate: expiryDate };
      dispatch(PagesMiddleware.createDiscountCode(data))
        .then((res) => {
          setdiscountVal("");
          setDiscountPercentage("");
          setExpiryDate("");
        })
        .catch((err) => { console.log("error", err) });
    }
  }

  const onClickDelCode = (id) => {
    dispatch(PagesMiddleware.onDelDiscountCode({ id: id }))
      .then((res) => { })
      .catch((err) => { console.log("error", err) });
  }



  return (
    <div className={styles.AccountContent}>
      <HeadingComponent text={"Manage Discount Codes"} fontSize={20} padding={'0px'} />

      <InputField
        style={{ marginTop: "30px" }}
        label={"Discount Code"}
        placeholder={"NEWYEARSALE2026"}
        value={discountVal}
        onChange={(e) => setdiscountVal(e.target.value)}
      />

      <InputField
        label={"Discount Percentage (%)"}
        placeholder={"50"}
        value={discountPercentage}
        type={"number"}
        onChange={(e) => setDiscountPercentage(e.target.value)}
      />



      <InputField
        disabled={true}
        label={"Discount Expiry Date"}
        placeholder={"Aug, 20 2026"}
        value={expiryDate ? moment(expiryDate).format("MMM, DD YYYY") : ""}
        rightIcon={
          <DatePicker
            value={expiryDate ? moment(expiryDate) : null}
            format={"YYYY-MM-DD"}
            disabledDate={(current) => {
              return current && current < moment().startOf("day");
            }}
            onChange={
              (date, dateString) => {
                setExpiryDate(dateString);
              }
            } />

        }

      />

      <SubmitButton
        title={"Add Discount Code"}
        btnClass={styles.BtnCard}
        primary
        onClick={onAddCode}
      />

      {DATA?.length == 0 ?

        (
          <span className={styles.noCodesText}>
            No discount codes added yet.
          </span>

        )


        : (
          <div className={styles.codesList}>
            {DATA?.length > 0 && DATA?.map((code, index) => (
              <div key={index} className={styles.codeItem}>
                <span className={styles.codeText}>Code #{index + 1}</span>

                <span className={styles.codeText} style={{ fontWeight: 'bold' }}>{code?.code}</span>
                <span className={styles.codeText}>{code?.percentage}% discount</span>
                <span className={styles.codeText}>Valid till : {code?.expiresAt ? moment(code?.expiresAt).format("MMM, DD YYYY") : ""}</span>

                <div
                  className={styles.removeButton}

                >
                  {/* <RxCross2 color={"var(--secondary-color)"} /> */}

                  <Popconfirm
                    title="Are you sure to delete this code?"
                    onConfirm={() => { onClickDelCode(code?.id) }}
                    okText="Yes"
                    cancelText="No"
                  >
                    <DeleteOutlined className={styles.deleteIcon} />
                  </Popconfirm>
                </div>
              </div>
            ))}

            {

              (DATA_PAGINATION?.totalPages > 1) &&
              <Pagination
                currentPage={currentPage}
                totalPages={DATA_PAGINATION?.totalPages}
                nextButton={(e) => {
                  getData({
                    limit: pageLimit,
                    page: currentPage + 1,
                  });
                  setCurrentPage(currentPage + 1);
                }}
                previousButton={(e) => {
                  getData({
                    limit: pageLimit,
                    page: currentPage - 1,
                  });
                  setCurrentPage(currentPage - 1);
                }}
              />
            }

          </div>
        )}


    </div>
  );
};

export default DiscountManagement;
